import { GraphQLClient, gql } from 'graphql-request';
import { DropdownOption, Localize } from './forms-types';

export const formsClient = new GraphQLClient('/api');

export const POST_FORM_QUERY = gql`
    mutation PostForm (
        $type: String,
        $siteCountry: String,
        $input: salesforce_PostFormInput,
        $referer: String!
        $captchaToken: String!
        $gotoEventId: String
        $sessionId: String
        $campaignId: String
    ) {
        postForm(
            type: $type,
            siteCountry: $siteCountry,
            input: $input,
            referer: $referer,
            captchaToken: $captchaToken,
            gotoEventId: $gotoEventId,
            sessionId: $sessionId,
            campaignId: $campaignId,
        ) {
            success
            reason
        }
    }
`;

// Keeping the values here exactly as Salesforce expects them, hence the uppercase first Letter.
export const getUserTypes = (localize: Localize): DropdownOption[] => [
    {
        value: 'HCP',
        text: localize('i-am-a-healthcare-professional', 'I am a healthcare professional'),
    },
    {
        value: 'Patient',
        text: localize('i-am-a-patient', 'I am a patient'),
    },
    {
        value: 'Relative',
        text: localize('i-am-a-relative', 'I am a relative'),
    },
    {
        value: 'Other',
        text: localize('other', 'Other'),
    },
];
